var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthcare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4389 26.876L14.2477 16.4636H16.7114L21.5778 34.6169L23.3578 27.8338L24.5937 26.8766H29.2477L32.0565 16.4642H34.5249L37.3325 26.8766H45.4185C45.9649 25.0966 46.3053 23.1763 46.3053 21.188C46.3047 13.7235 40.551 7.69336 33.4949 7.69336C29.7988 7.69336 26.3726 9.40761 24.0404 12.0127C21.714 9.40761 18.3582 7.69336 14.6574 7.69336C7.60133 7.69336 1.78125 13.7235 1.78125 21.1874C1.78125 23.1758 2.19207 25.096 2.74021 26.876H11.4389Z",
    fill: "#F48000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3017 29.4786H44.3871C38.9737 41.1252 24.0389 48.6583 24.0389 48.6583C24.0389 48.6583 9.17564 41.1252 3.76172 29.4786H12.3947L13.6265 28.5185L15.4775 21.7383L20.3439 39.8933H22.8076L25.6164 29.4786H30.2087L31.4406 28.5185L33.2206 21.7383L35.0704 28.5185L36.3023 29.4786H36.3017Z",
    fill: "#FFE4C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/Healthcare.ebe236c835230b7a7dc705d93f4b5107.svg";
export { ForwardRef as ReactComponent };